define.alias("shared/components/shared/wizard/previous-button", "preview-grid/components/shared/wizard/previous-button");